module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'tracking/base' && templateVars.config ?
				templateVars.config :
				{
	"printOnlyGoogle": true,
	"systems": {
		"ar": {
			"ru": {
				"yandex": {
					"id": 61218406,
					"trackGoals": true,
					"userVisitedGoalID": "userVisited"
				},
				"google": {
					"id": "GTM-NXQDGJ4"
				}
			},
			"en": {
				"yandex": {
					"id": 61218406,
					"trackGoals": true,
					"userVisitedGoalID": "userVisited"
				},
				"google": {
					"id": "GTM-NXQDGJ4"
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/tracking/.variant/base/config.yaml
// module id = 137
// module chunks = 0